import React, { useState } from 'react';
import { Button, Stack, Typography } from '@mui/material';
import CustomTextInput from '../../../components/CustomTextInput';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { authApiClient } from '../../../utils/axios';
import { showSnackbar } from '../../../api/snackbarSlice';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import logo from '../../../assets/logo/marmin_logo.png';

export const SignupEmailSchema = Yup.object().shape({
  email: Yup.string().email('Invalid email format').required('Email is required'),
});

const SignupEmailForm = () => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {
    control,
    handleSubmit,
    formState: { errors },
    setValue,
    watch,
    trigger,
    setError,
  } = useForm({
    resolver: yupResolver(SignupEmailSchema),
  });

  const onSubmit = async (data) => {
    setLoading(true);
    authApiClient
      .post('/check-email', data)
      .then((res) => {
        if (res.data.status.toLowerCase() === 'new') {
          navigate('/signup', { replace: true, state: { email: data.email } });
        } else if (res.data.status.toLowerCase() === 'unverified') {
          navigate('/signup', { replace: true, state: { email: data.email, stage: 'verification' } });
          dispatch(
            showSnackbar({
              message: 'Email already exists. Please check your email for verification.',
              severity: 'info',
            }),
          );
        } else {
          setError('email', {
            message:
              'User already exists with the provided email. Please try again with a different email or try logging in.',
          });
        }
      })
      .catch((err) => {
        dispatch(
          showSnackbar({
            message: err?.response?.data?.errors?.message ?? 'Something went wrong.',
            severity: 'error',
          }),
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <>
      <Stack sx={{ alignItems: 'center', mb: 4 }}>
        <img src={logo} alt="logo" width="50%" />
      </Stack>
      <Stack spacing={2}>
        <CustomTextInput name="email" label="Email" control={control} errors={errors} />
        <Button type="button" variant="contained" className="submit" onClick={handleSubmit(onSubmit)}>
          {loading ? 'Checking Email...' : 'Sign Up'}
        </Button>
        <Typography variant="body2">
          <Link to="/login" style={{ textDecoration: 'none' }}>
            Already have an account? Sign In
          </Link>
        </Typography>
      </Stack>
    </>
  );
};

export default SignupEmailForm;
